<template lang="pug">
  div
    ods-table(v-loading="isloadingCLCAC"
      style='width: 100%'
      :height="lessHeight ? '35vh' : '56vh'"
      size="medium"
      :data='tableDataToRender'
      :row-key="codcuent"
      :row-class-name="tableRowClassName"
      @selection-change='handleSelectionChange')
      ods-table-column(type='selection' :reserve-selection='true' :selectable='selectable' width='55')
      ods-table-column(prop='LOYALTYACCOUNT' :label="$t('loyalty.loyaltyAccount')")
        template(slot-scope="scope")
          div {{ scope.row.codcuent }}
      ods-table-column(prop='IDCLIENTE' :label="$t('loyalty.dni')")
        template(slot-scope="scope")
          ods-tag(type="info" size="medium") {{ scope.row.destipc }}: {{ scope.row.idclient }}
      ods-table-column(prop='CLIENTE' :label="$t('loyalty.client')")
        template(slot-scope="scope")
          div {{ scope.row.nombre }} {{ scope.row.apellido1 }} {{ scope.row.apellido2 }}
      ods-table-column(prop='ESTADO' :label="$t('loyalty.currentstate')" width="140px")
        template(slot-scope="scope")
          ods-tag(size="medium" :color="scope.row.estado === 'ABIERTA' ? '#79C5B4' : scope.row.estado === 'BLOQUEADA' ? '#F7AC6F' : '#E88AA2'") {{ scope.row.estado === 'ABIERTA' ? $t('loyalty.opened') : scope.row.estado === 'BLOQUEADA' ? $t('loyalty.blocked') : scope.row.estado === 'CERRADA' ? $t('loyalty.closed') : scope.row.estado }}
      ods-table-column(prop='FECHALTA' :label="$t('terminalDetail.highDate')" align="center" width="100px").hidden-md-and-down
        template(slot-scope="scope")
          div {{scope.row.fechalta | formatDateLocale}}
      ods-table-column(prop='INDBLQAC' :label="$t('loyalty.accumulationBlockage')" align="center" width="100px")
        template(slot-scope="scope")
          div {{ scope.row.indblqac }}
      ods-table-column(prop='INDBLQRD' :label="$t('loyalty.redeemableLock')" align="center" width="100px")
        template(slot-scope="scope")
          div {{ scope.row.indblqrd }}
      ods-table-column(prop='CANTPUNT' :label="$t('loyalty.totalPoints')" align="right" width="110px")
        template(slot-scope="scope")
          div {{ scope.row.cantpunt }}
      ods-table-column(prop='CUPASIG' :label="$t('loyalty.couponsAssigned')" align="right" width="110px")
        template(slot-scope="scope")
          div {{ scope.row.cupasig }}
      ods-table-column(prop='CUPUTILIZ' :label="$t('loyalty.couponsUsed')" align="right" width="110px")
        template(slot-scope="scope")
          div {{ scope.row.cuputiliz }}
    div.footer
      paginator-table(v-if="tableDataToRender!==null"
        :isNextPage="paginationParams.indMasDatos"
        :currentPage="paginationParams.pantPagina"
        @buttonPrevAction="getData(false)"
        @buttonNextAction="getData(true)")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'AccountsCouponTable',
  props: ['tipCons', 'lessHeight', 'filterText'],
  components: { 'paginator-table': Paginator },
  data () {
    return {
      tableData: null,
      tableDataToRender: null,
      rowsSelected: [],
      paginationParams: {
        currentPage: 1,
        indMasDatos: 'N',
        claveInicio: 1,
        claveFin: 20
      }
    }
  },
  computed: {
    ...mapGetters(['isloadingCLCAC', 'isReloadAccountsToAssign'])
  },
  methods: {
    ...mapActions(['getCLCAC', 'setReloadAccountsToAssign']),
    async getData (pagina) {
      let params = { ...this.paginationParams }
      if (typeof pagina !== 'undefined') {
        // console.log('paginando')
        params = pagina ? { ...this.params, ...this.paginationParams, avanzar: true } : { ...this.params, ...this.paginationParams, retroceder: true }
      }
      this.getCLCAC(params).then(resData => {
        if (resData && resData.registros && resData.retorno === '000') {
          this.tableData = Array.isArray(resData.registros) ? resData.registros : [resData.registros]
          this.tableDataToRender = this.tableData
          this.paginationParams = {
            pantPagina: resData.pantPagina,
            indMasDatos: resData.indMasDatos,
            claveInicio: resData.claveInicio,
            claveFin: resData.claveFin
          }
        } else {
          this.tableData = null
          this.tableDataToRender = this.tableData
        }
        this.setReloadAccountsToAssign(false)
      }).catch(err => {
        console.log('getCLCAC params error', params, err)
      })
    },
    handleSelectionChange (rows) {
      this.rowsSelected = rows
      this.$emit('rows', rows)
    },
    codcuent (row) {
      return row.codcuent
    },
    selectable (row) {
      if (this.rowsSelected.some(e => e.codcuent === row.codcuent)) {
        return true
      } else {
        return row.asignar === 'SI' && this.rowsSelected.length < 20
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      return `ods-table__row--${
          row.asignar === 'SI' ? ''
          : row.asignar === 'NO' ? ''
          : ''
      }`
    }
  },
  watch: {
    isReloadAccountsToAssign (newVal, oldVal) {
      // console.log('isReloadAccountsToAssign', newVal, oldVal)
      if (newVal === true) {
        this.getData()
      }
    },
    async filterText (text) {
      if (this.tableData) {
        this.tableDataToRender = await this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
      }
    }
  }
}
</script>

<style lang="scss">
</style>
